import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import {
  actionGetEvents,
  actionDeleteEvent,
  actionStatisticsByEvent,
  actionSelectEvent,
  actionExportEvents
} from "../actions/EventActions";
import {
  LOGIN_ROUTE,
  EVENTS_ADD_ROUTE,
  EVENTS_EDIT_ROUTE,
  EVENTS_COPY_ROUTE,
  EVENTS_STATISTICS_ROUTE,
  TICKETS_ROUTE,
  TICKET_TYPES_ROUTE,
} from "../config/RoutesConstants";
import {
  Container,
  IconButton,
  Icon,
  Button,
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography,
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  Input,
} from "@material-ui/core";
import { withTheme } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import TicketIcon from "@material-ui/icons/ConfirmationNumber";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import CopyIcon from "@material-ui/icons/FileCopy";
import StatisticsIcon from "@material-ui/icons/BarChart";
import Util, { ERROR } from "../common/Util";
import Settings from "../provider/base/Settings";
import ExcelIcon from "@material-ui/icons/CloudDownload";

class Events extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowPerPage: 5,
      count: 0,
      events: [],
      filter: "",
      eventForDelete: false,
    };
    this.renderTableHeader = this.renderTableHeader.bind(this);
    this.renderTableBody = this.renderTableBody.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
    this.getDeleteEventSuccess = this.getDeleteEventSuccess.bind(this);
    this.onConfirmDeleteEvent = this.onConfirmDeleteEvent.bind(this);
    this.onAddEvent = this.onAddEvent.bind(this);
    this.onCopyEvent = this.onCopyEvent.bind(this);
    this.onStatisticEvent = this.onStatisticEvent.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onExport = this.onExport.bind(this)
  }

  componentWillMount() {
    if (this.props.login) {
      this.props.actionGetEvents(this.onChangePage, this.getEventsError);
    }
  }

  getEventsError(e) {
    console.log("ERROR EVENTS", e);
    if (!(e && e.status && e.status == 401))
      Util.showNoty(ERROR, "Ocurrió un error al listar los eventos.");
  }

  onExport(){
    this.props.actionExportEvents( {
      search: this.state.filter
    },
    (response) => {
      console.log("EXPORTADO", response)
      setTimeout(() => {
        window.open(response, '_self');
      }, 200);
    },
    (e)=>{
      if (!(e && e.status && e.status == 401))
      Util.showNoty(ERROR, "Ocurrió un error al exportar los eventos.");
    })
  }

  onChangePage(evt = null, newPage = 0) {
    let from = newPage * this.state.rowPerPage;
    let end = from + this.state.rowPerPage;
    let filter = new RegExp(this.state.filter, "ig");
    let events = this.props.eventList.filter((e) => {
      return e.evtName.match(filter);
    });
    let count = events.length;
    events = events.slice(from, end);
    this.setState({ page: newPage, count: count, events: events });
  }

  onChangeRowsPerPage(evt) {
    let from = this.state.page * evt.target.value;
    let end = from + evt.target.value;
    let filter = new RegExp(this.state.filter, "ig");
    let events = this.props.eventList.filter((e) => {
      return e.evtName.match(filter);
    });
    let count = events.length;
    events = events.slice(from, end);
    this.setState({
      rowPerPage: evt.target.value,
      count: count,
      events: events,
    });
  }

  onSearch(evt) {
    this.setState({ filter: evt.target.value }, this.onChangePage);
  }

  onStatisticEvent(event) {
    this.props.actionStatisticsByEvent(
      event,
      () => this.props.history.push(EVENTS_STATISTICS_ROUTE),
      this.getStatisticEventError
    );
  }

  getStatisticEventError(e) {
    console.log("ERROR", e);
    if (!(e && e.status && e.status == 401))
      Util.showNoty(
        ERROR,
        "Ocurrió un error al consultar las estadísticas del evento."
      );
  }

  onCopyEvent(event) {
    this.props.actionSelectEvent(event);
    this.props.history.push(EVENTS_COPY_ROUTE);
  }

  onAddEvent() {
    this.props.history.push(EVENTS_ADD_ROUTE);
  }

  onTicketTypes(event) {
    this.props.actionSelectEvent(event);
    this.props.history.push(TICKET_TYPES_ROUTE);
  }

  onTickets(event) {
    this.props.actionSelectEvent(event);
    this.props.history.push(TICKETS_ROUTE);
  }

  onEditEvent(event) {
    this.props.actionSelectEvent(event);
    this.props.history.push(EVENTS_EDIT_ROUTE);
  }

  onConfirmDeleteEvent() {
    this.props.actionDeleteEvent(
      this.state.eventForDelete,
      this.getDeleteEventSuccess,
      this.getDeleteEventError
    );
    this.setState({ eventForDelete: false });
  }

  onDeleteEvent(event) {
    this.setState({ eventForDelete: event });
  }

  getDeleteEventSuccess() {
    this.props.actionGetEvents(() => {
      this.onChangePage(null, this.state.page);
    }, this.getEventsError);
  }

  getDeleteEventError(e) {
    console.log("ERROR", e);
    if (!(e && e.status && e.status == 401))
      Util.showNoty(ERROR, "Ocurrió un error al elminar el evento.");
  }

  renderTableHeader() {
    const { theme } = this.props;
    let headers = [
      "Nombre",
      "Descripción",
      "Fecha",
      "Status",
      "Creado por",
      "Modificado por",
    ];
    if (Settings.IS_USER_VERIFIED) {
      headers.splice(2, 0, "Venta verificada");
    }
    return (
      <TableRow>
        {headers.map((label) => {
          return <TableCell>{label}</TableCell>;
        })}
        <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
      </TableRow>
    );
  }

  renderTableBody() {
    const { theme } = this.props;
    let events = this.state.events;
    if (!events || events.length == 0) {
      return <Box style={theme.table.empty}>No se encontraron registros</Box>;
    }
    return events.map((item, index) => {
      // console.log(index, item)
      let isActive = item.evtState.toLowerCase() == "active";
      let isVerified = item.evtSellVerify;

      return (
        <TableRow
          style={index % 2 == 0 ? theme.table.row : theme.table.rowColor}
        >
          <Tooltip interactive enterDelay={10} title={item.id}>
            <TableCell>{item.evtName}</TableCell>
          </Tooltip>
          <TableCell>{item.evtDescription}</TableCell>
          {Settings.IS_USER_VERIFIED && (
            <TableCell
              style={
                isVerified
                  ? theme.table.activeCell
                  : theme.overrides.MuiTableCell.body
              }
            >
              {isVerified ? "SI" : "NO"}
            </TableCell>
          )}
          <TableCell>
            {Util.formatDateToShow(Util.timestampToMoment(item.evtDateTime))}
          </TableCell>
          <TableCell
            style={
              isActive
                ? theme.table.activeCell
                : theme.overrides.MuiTableCell.body
            }
          >
            {isActive ? "ACTIVO" : "INACTIVO"}
          </TableCell>
          <TableCell>{item.evtCreateUser}</TableCell>
          <TableCell>{item.evtLastUpdateUser}</TableCell>
          <TableCell style={{ ...theme.table.actionsColumn, minWidth: 256 }}>
            <Tooltip title="Gestionar tickets">
              <IconButton onClick={this.onTickets.bind(this, item)}>
                <Icon className="fa fa-film" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Estadísticas del evento">
              <IconButton onClick={this.onStatisticEvent.bind(this, item)}>
                <StatisticsIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Copiar evento">
              <IconButton onClick={this.onCopyEvent.bind(this, item)}>
                <CopyIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Gestionar tipos de tickets">
              <IconButton onClick={this.onTicketTypes.bind(this, item)}>
                <TicketIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Editar evento">
              <IconButton onClick={this.onEditEvent.bind(this, item)}>
                <EditIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar evento">
              <IconButton onClick={this.onDeleteEvent.bind(this, item)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      );
    });
  }

  render() {
    const { theme, eventList } = this.props;
    return (
      <Box style={theme.mainContainer}>
        <Box style={theme.title.container}>
          <Typography variant="h1">Eventos</Typography>
          <Typography variant="subtitle1">Crea eventos</Typography>
        </Box>
        <Container style={theme.table.container}>
          <Paper>
            <Typography style={theme.paper.title} variant="h2">
              Listado de eventos
            </Typography>
            <Toolbar style={theme.table.toolbar}>
              <Box>
                <Tooltip title="Crear nuevo evento">
                  <Fab color="primary" onClick={this.onAddEvent} size="small">
                    <AddIcon />
                  </Fab>
                </Tooltip>
                <Tooltip title="Descargar listado de eventos">
                  <Fab
                    onClick={this.onExport}
                    size="small"
                    style={{ marginLeft: 16 }}
                    color="secondary"
                  >
                    <ExcelIcon size="small" />
                  </Fab>
                </Tooltip>
              </Box>
              <Box>
                <Input placeholder="Buscar" onChange={this.onSearch} />
              </Box>
            </Toolbar>
            <Table stickyHeader>
              <TableHead>{this.renderTableHeader()}</TableHead>
              <TableBody>{this.renderTableBody()}</TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.eventForDelete}>
            <DialogTitle>Eliminar Evento</DialogTitle>
            <DialogContent>
              <DialogContentText>
                ¿Está seguro que desea eliminar el evento?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  this.setState({ eventForDelete: null });
                }}
              >
                Cancelar
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={this.onConfirmDeleteEvent}
              >
                Eliminar
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    );
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    eventList: store.evt.eventList,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetEvents,
      actionDeleteEvent,
      actionStatisticsByEvent,
      actionSelectEvent,
      actionExportEvents
    },
    dispatch
  );
}

export default withRouter(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(Events))
);



// WEBPACK FOOTER //
// ./src/screens/Events.js